import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { aporte } from '@constants/URL'

class APIDetailsAsset extends APITemplate {
  /**
   * Movimentações do cliente agrupadas por ativo (fonte da aba Movimentações
   * e dos marcadores do gráfico).
   * @param {Object} params
   * @param {Boolean} params.isClient Contexto cliente final
   * @param {String|Number} params.clienteId id_cliente_app
   * @returns {Object} response { status, message, value } — value keyed por id_ativo_cliente
   */
  async listMovementsGroupedByAsset({ isClient, clienteId } = {}) {
    if (!clienteId) {
      return {
        status: 400,
        message: 'Cliente não informado',
        value: null,
      }
    }
    const url = isClient
      ? aporte.client.list_grouped
      : aporte.professional.list_grouped
    const r = await con.post(url, { id_cliente_app: clienteId })
    return (
      r || {
        status: 500,
        message: 'Erro ao carregar as movimentações',
        value: null,
      }
    )
  }

  /**
   * Remove uma movimentação do ativo.
   * @param {Object} params
   * @param {Boolean} params.isClient Contexto cliente final
   * @param {Object} params.movement Movimentação (id_conta, id_aplicacao, id_cliente)
   * @returns {Object} response { status, message }
   */
  removeMovement({ isClient, movement } = {}) {
    const data = {
      id_conta: movement.id_conta,
      id_aplicacao: movement.id_aplicacao,
      id_cliente_app: movement.id_cliente,
    }
    if (isClient) {
      return con.post(aporte.client.del, data)
    }
    return con.delet(aporte.professional.manage + movement.id_aplicacao, data)
  }
}

const apiDetailsAsset = new APIDetailsAsset()
export { apiDetailsAsset }
